import { render, staticRenderFns } from "./HTMLinput.vue?vue&type=template&id=1601a3f0&"
import script from "./HTMLinput.vue?vue&type=script&lang=js&"
export * from "./HTMLinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1601a3f0')) {
      api.createRecord('1601a3f0', component.options)
    } else {
      api.reload('1601a3f0', component.options)
    }
    module.hot.accept("./HTMLinput.vue?vue&type=template&id=1601a3f0&", function () {
      api.rerender('1601a3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/HTMLinput.vue"
export default component.exports